import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Steps } from "@/components/Steps";
import { MenuSection } from "@/components/MenuSection";
import { CartPanel } from "@/components/CartPanel";
import { MobileCart } from "@/components/MobileCart";
import { Footer } from "@/components/Footer";
import { Gallery } from "@/components/Gallery";
import { Location } from "@/components/Location";
import { PromoBanner } from "@/components/PromoBanner";
import { useCart } from "@/context/CartContext";
import { api, errMsg } from "@/lib/api";

export default function Home() {
  const [menu, setMenu] = useState([]);
  const [loading, setLoading] = useState(true);
  const [params] = useSearchParams();
  const { hash } = useLocation();
  const { setSeat, syncWithMenu, setShop, setOutlet } = useCart();

  useEffect(() => {
    Promise.all([api.get("/outlets"), api.get("/settings")]).then(([o, s]) => {
      setShop({ outlets: o.data, taxRate: s.data.tax_rate, taxName: s.data.tax_name });
      const fromUrl = (params.get("gerai") || "").toUpperCase();
      setOutlet((cur) => {
        const want = fromUrl || cur;
        return o.data.some((x) => x.code === want) ? want : o.data[0]?.code || "";
      });
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    api.get("/menu").then((r) => { setMenu(r.data); syncWithMenu(r.data); }).catch((e) => toast.error(errMsg(e))).finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const floor = Number(params.get("lantai"));
    const table = Number(params.get("meja"));
    if (floor >= 1 && floor <= 2 && table >= 1 && table <= 15) setSeat({ floor, table });
  }, [params, setSeat]);

  useEffect(() => {
    if (hash) setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 300);
  }, [hash]);

  return (
    <div className="min-h-screen bg-cream">
      <Header />
      <Hero />
      <Steps />
      <PromoBanner menu={menu} />
      <main className="wrap mt-12 sm:mt-16 grid lg:grid-cols-[1fr_380px] gap-8 items-start">
        <MenuSection menu={menu} loading={loading} />
        <aside className="hidden lg:block sticky top-24">
          <CartPanel />
        </aside>
      </main>
      <Gallery />
      <Location />
      <Footer />
      <MobileCart />
    </div>
  );
}
